import {createFileRoute} from '@tanstack/react-router';

import {SettingsLayout} from '@/modules/settings/components/SettingsLayout';

export const Route = createFileRoute('/_authenticated/account')({
  component: SettingsLayout,
});
